import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { forkJoin } from 'rxjs';
import { ActivityItem, DealSubmission } from 'src/app/models/community';
import { CommunityService } from 'src/app/services/community.service';
import { I18nService } from 'src/app/services/i18n.service';
import { formatDate } from '../account-sections';

type ContributionTab = 'activity' | 'deals' | 'comments';

@Component({
  selector: 'app-contributions',
  templateUrl: './contributions.component.html',
  styleUrls: ['./contributions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContributionsComponent implements OnInit {

  tab: ContributionTab = 'activity';
  activity: ActivityItem[] = [];
  submissions: DealSubmission[] = [];
  loading = true;
  error = '';

  constructor(
    private communityService: CommunityService,
    private snackBar: MatSnackBar,
    public i18n: I18nService
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    forkJoin({ activity: this.communityService.activity(), submissions: this.communityService.mySubmissions() }).subscribe({
      next: ({ activity, submissions }) => {
        this.activity = activity;
        this.submissions = submissions;
        this.loading = false;
      },
      error: err => {
        this.error = err || this.i18n.t('account.loadError');
        this.loading = false;
      }
    });
  }

  get comments(): ActivityItem[] {
    return this.activity.filter(item => item.type === 'comment');
  }

  date(value: string): string {
    return formatDate(value, this.i18n.current);
  }

  cancel(submission: DealSubmission): void {
    if (!confirm(this.i18n.t('account.contributions.cancelConfirm'))) {
      return;
    }
    this.communityService.cancelSubmission(submission._id).subscribe({
      next: () => {
        this.submissions = this.submissions.filter(s => s._id !== submission._id);
        this.activity = this.activity.filter(item => !(item.type === 'deal' && item.text === submission.title && item.status === 'pending'));
        this.snackBar.open(this.i18n.t('account.contributions.cancelled'), undefined, { duration: 2500 });
      },
      error: err => this.snackBar.open(err || this.i18n.t('common.errorOccurred'), this.i18n.t('common.close'), { duration: 4000 })
    });
  }
}
